import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
import { company } from '../data/company';
export function NotFound() {
  const {
    t
  } = useLanguage();
  useSeo({
    title: `${t('nf.title')} | ${company.shortName}`,
    description: t('nf.body')
  });
  return <section className="mx-auto flex min-h-[60vh] max-w-page flex-col items-center justify-center px-4 py-24 text-center sm:px-6 lg:px-8" data-id="element-444" data-mp="152v0f1abxa1u">
      <p className="font-display text-6xl font-extrabold text-navy" data-id="element-445" data-mp="1f2lskwbf3cyr">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold text-navy" data-id="element-446" data-mp="1jtu3xxwb58ek">{t('nf.title')}</h1>
      <p className="mt-3 max-w-md text-base text-ink-muted" data-id="element-447" data-mp="1jw7ym5n2sill">{t('nf.body')}</p>
      <Link to="/" className="mt-8 inline-flex rounded-md bg-cta px-6 py-3.5 text-base font-bold text-white transition-colors duration-200 ease-smooth hover:bg-cta-dark" data-id="element-448" data-mp="1nunt0ulhkt91">
        {t('nf.cta')}
      </Link>
    </section>;
}